import { ThemeProvider, createTheme } from "@mui/material/styles";

import Slide from "react-reveal/Slide";
import Mail from "./mail";
import Navbar from "../components/navbar";
import About from "./about";
import Service from "./services";
import Testimonial from "./testimonial";
import Portfolio from "./portfolio";
import Team from "./team";
import Contact from "./contact";
import GoToTop from "../components/gototop";
import Home from "./home";
import Performance from "./performance";

const theme = createTheme({
  typography: {
    fontFamily: ["montserrat", "sans-serif"].join(","),
  },
  button: {
    fontFamily: ["montserrat", "sans-serif"].join(","),
  },
});

function Allcontainers() {
  return (
    <>
      <Mail />
      <Navbar />
      <Home />
      <Slide bottom>
        <About />
        <Performance />
        <Service />
        <Testimonial />
      </Slide>
      <Portfolio />
      <Slide bottom>
        <Team />
        <Contact />
      </Slide>
      <GoToTop />
    </>
  );
}

export default Allcontainers;
